import { PlusOutlined, UpCircleOutlined } from '@ant-design/icons';
import {
	Button,
	Col,
	Divider,
	Form,
	Input,
	Modal,
	Row,
	Select,
	Space,
	Switch,
	Tooltip,
	TreeSelect,
	InputNumber,
	message,
	Card,
} from 'antd';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { chartOfAccountAction } from 'redux/action/chartOfAccountAction';
import { postApi } from 'redux/apis';
import { AppDispatch } from 'redux/store';
import {
	BlueAddSvg,
	CloseSvg,
	DeleteActionSvg,
	EditActionSvg,
	// TickMark,
	ToolTipInfo,
} from 'utils/svgs';
import { checkPermission, filterQBEntities, toastText } from 'utils/utils';
import styles from './index.module.scss';
import './index.scss';
import { SingleMappingSection } from './types';
import { DetailType } from 'constants/Data';
import { showNotification } from 'utils/notification';
import WrappingEllipse from 'components/CostAllocation/Ellipse';
// for mapping the our column with  QB
const MappingBox: FC<SingleMappingSection> = (props) => {
	// inits
	const {
		singleMappingSection,
		qbSelectionObj,
		settingsChangeHandler,
		isFirstTimeSubmit,
		allMappingSection,
		addFieldHandler,
		deleteFieldHandler,
		// showModal,
		indirectExpenseRate,
		onChangeFieldStatus,
		onChangeFieldPriority,
		customerSection,
	} = props;

	if (singleMappingSection.id === '4' || singleMappingSection.id === '6') {
		return null;
	}
	const selectedCompanyPermission = useSelector(
		(state: any) => state?.companies?.selectedCompanyDetails?.role?.permissions
	);
	const qbValues = qbSelectionObj?.[singleMappingSection.type] || [];

	const [detailTypeOptions, setDetailTypeOptions] = useState<any>([]);
	// const [detailTypeValue, setDetailTypeValue] = useState(null);
	const [form] = Form.useForm();

	const handleAccountTypeChange = (value: any) => {
		setDetailTypeOptions(DetailType[value as keyof typeof DetailType]);
		// setDetailTypeValue(null);
		form.setFieldsValue({ detailType: undefined });
	};
	// for check is there add permission
	const isAddIntegrationPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Configurations',
			permission: ['add'],
		}
	);
	useEffect(() => {
		handleAccountTypeChange('Expense');
		// console.log('singleMappingSection', singleMappingSection);
		// or whatever defaultValue you have
	}, []);

	// for check is there add permission
	const isEditIntegrationPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Configurations',
			permission: ['edit'],
		}
	);

	// for check is there add permission
	const isDeleteIntegrationPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Configurations',
			permission: ['delete'],
		}
	);

	// For filter out the selected items
	const filteredItems = filterQBEntities(
		allMappingSection,
		singleMappingSection.type,
		qbValues
	);

	// For customer section (section 5) if it exists
	const customerFilteredItems = customerSection
		? filterQBEntities(
				allMappingSection,
				customerSection.type,
				qbSelectionObj?.[customerSection.type] || []
		  )
		: [];

	function findRecursively(arr: any, key: string, value: string) {
		for (const obj of arr) {
			if (obj[key] === value) {
				return obj;
			}
			if (obj.children && Array.isArray(obj.children)) {
				const result: any = findRecursively(obj.children, key, value);
				if (result) {
					return result;
				}
			}
		}
		return null;
	}

	// For select the initial value
	const findSelectBoxValueHandler = (singleMapping: any) => {
		const foundedElement: any = findRecursively(
			qbValues,
			'Id',
			singleMapping?.value
		);

		// const foundedElement = qbValues.find(
		// 	(singleEl: any) => singleEl?.Id === singleMapping?.value
		// );
		if (singleMappingSection.type === 'qbCoa') {
			return foundedElement?.Name;
		} else if (singleMappingSection.type === 'qbCustomer') {
			return foundedElement?.title;
			// return foundedElement?.DisplayName;
		} else if (singleMappingSection.type === 'qbClass') {
			return foundedElement?.title;
		}
	};

	const findSelectBoxValueHandlerForCustomer = (singleMapping: any) => {
		if (qbSelectionObj?.[customerSection.type]) {
			const foundedElement: any = findRecursively(
				qbSelectionObj?.[customerSection.type],
				'Id',
				singleMapping?.value
			);
			return foundedElement?.title;
		}
	};

	const dispatch = useDispatch<AppDispatch>();
	const [isNewAccountModalOpen, setIsNewAccountModalOpen] = useState(false);
	const [isAccountLoading, setIsAccountLoading] = useState(false);

	const handleModalClose = () => {
		setIsNewAccountModalOpen(false);
	};

	const handleSubmit = async (values: any) => {
		try {
			setIsAccountLoading(true);
			await postApi(`/quickbooks/chart-of-account`, {
				companyId: localStorage.getItem('companyId'),
				accountName: values.accountName,
				accountNum: values.accountNumber,
				accountType: values.accountType,
				detailType: values.detailType,
			});
			toastText('New QuickBooks account created successfully', 'success');
			await dispatch(chartOfAccountAction());
			setIsAccountLoading(false);
			handleModalClose();
		} catch (err: any) {
			if (
				err?.response?.data?.message ===
				'QuickBooks session expired. Please reconnect your company to continue.'
			) {
				showNotification({
					type: 'error',
					message: 'Session Expired',
					description: err.response.data.message,
				});
			}

			if (err?.response?.data?.message) {
				toastText(err?.response?.data?.message, 'error');
			} else {
				toastText(
					'Something went wrong in creating new QuickBooks account',
					'error'
				);
			}
			setIsAccountLoading(false);
		}
	};

	// State to handle modal visibility
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [singleMappingToDelete, setSingleMappingToDelete] = useState<{
		id?: string;
		label?: string;
	} | null>(null);
	const [singleMappingSectionToDelete, setSingleMappingSectionToDelete] =
		useState<{
			id?: string;
		} | null>(null);

	// Function to handle showing the modal
	const showModal = (mapping: any, singleMappingSection: any) => {
		setSingleMappingToDelete(mapping);
		setSingleMappingSectionToDelete(singleMappingSection);
		setIsModalVisible(true);
	};

	// Function to handle the delete action
	const handleDelete = () => {
		// Replace with your actual delete logic
		if (singleMappingSectionToDelete?.id && singleMappingToDelete?.id) {
			deleteFieldHandler(
				singleMappingSectionToDelete.id,
				singleMappingToDelete.id
			);
			message.success('Field deleted successfully!');
			setIsModalVisible(false); // Close the modal after deletion
		}
	};

	// Function to close the modal without doing anything
	const handleCancel = () => {
		setIsModalVisible(false);
	};

	if (singleMappingSection.id === '0' && customerSection) {
		return (
			<div
				className={`${styles['mapping-box']} ${
					!(
						isAddIntegrationPermission ||
						isEditIntegrationPermission ||
						isDeleteIntegrationPermission
					) && `${styles['remove-last']}`
				}`}
			>
				<div className={styles['mapping-box__wrapper']}>
					{/* Header section with both titles inline */}
					<div className={styles['mapping-box__top']}>
						<div className={styles['mapping-box__top--title-wrapper']}>
							<Tooltip title={singleMappingSection.toolTip}>
								<h5
									className={`${styles['mapping-box__top--title']} ${styles['mapping-box__top--title-cap']}`}
								>
									{singleMappingSection.capMappingTitle}
								</h5>
							</Tooltip>
						</div>

						{/* Customer header inline */}
						<h5
							className={`${styles['mapping-box__top--title']} ${styles['mapping-box__top--title-qb']}`}
						>
							{customerSection.qbMappingValue}
						</h5>

						<h5
							className={`${styles['mapping-box__top--title']} ${styles['mapping-box__top--title-qb']} ${styles['mapping-box__top--title-qb-tooltip']} ${styles['mapping-box__top--title-tooltip']}`}
						>
							{singleMappingSection.qbMappingValue}{' '}
							{/* <Tooltip
								title={
									'Only Classes with subclasses will get synced for e.g. Parent Class: Sub Class'
								}
							>
								<div>
									<InfoCircleOutlined style={{ fontSize: '18px' }} />
								</div>
							</Tooltip> */}
						</h5>
					</div>

					{/* Content section */}
					<div className={styles['mapping-box__center']}>
						{Object.values(singleMappingSection.fields)
							.sort((a: any, b: any) => a.priority - b.priority)
							.map((singleMapping: any, index: number) => {
								if (singleMapping.id === 'f2') {
									return null;
								}

								const selectBoxValue = findSelectBoxValueHandler(singleMapping);
								const customerSelectBoxValue =
									findSelectBoxValueHandlerForCustomer(
										customerSection.fields.f1
									);

								return (
									<div
										key={index}
										className={styles['mapping-box__center--wrapper']}
									>
										<div
											className={`${styles['mapping-box__center--single-mapping']} ${styles['inline-mapping']}`}
										>
											{/* Section 0 field */}
											<div
												className={
													styles[
														'mapping-box__center--single-mapping--svg-wrapper'
													]
												}
											>
												<div className={styles['field-label']}>
													<>
														<h4
															id={`${singleMappingSection.id}${singleMapping.id}`}
															style={{ fontSize: '12px' }}
														>
															{singleMapping.label}
														</h4>
														{/* {singleMapping.isActive && (
															<span className="required-field">*</span>
														)} */}
													</>
												</div>
											</div>

											{/* Customer section dropdown inline */}
											<div
												className={
													styles[
														'mapping-box__center--single-mapping--select-wrapper'
													]
												}
											>
												<TreeSelect
													showSearch
													placeholder={customerSection.placeHolder}
													size="large"
													getPopupContainer={(trigger) => trigger.parentNode}
													value={customerSelectBoxValue}
													onChange={(dataValue) => {
														settingsChangeHandler({
															sectionId: customerSection.id,
															fieldId: 'f1',
															fieldName: 'value',
															dataId: dataValue,
														});
													}}
													dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
													allowClear={false}
													treeDefaultExpandAll
													treeData={customerFilteredItems}
													filterTreeNode={(inputValue, treeNode) => {
														return treeNode.props.title
															.toLowerCase()
															.includes(inputValue.toLowerCase());
													}}
												/>
												{/* {!isFirstTimeSubmit && !customerSection.fields.f1.value && customerSection.fields.f1.isActive && (
													<p className="error-message">
														{customerSection.errorMessage}
													</p>
												)} */}
											</div>

											{/* Section 0 dropdown */}
											<div
												className={
													styles[
														'mapping-box__center--single-mapping--select-wrapper'
													]
												}
											>
												<TreeSelect
													showSearch
													placeholder={singleMappingSection?.placeHolder}
													size="large"
													getPopupContainer={(trigger) => trigger.parentNode}
													value={selectBoxValue}
													onChange={(dataValue) => {
														settingsChangeHandler({
															sectionId: singleMappingSection.id,
															fieldId: singleMapping.id,
															fieldName: 'value',
															dataId: dataValue,
														});
													}}
													dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
													allowClear={false}
													treeDefaultExpandAll
													treeData={filteredItems}
													filterTreeNode={(inputValue, treeNode) => {
														return treeNode.props.title
															.toLowerCase()
															.includes(inputValue.toLowerCase());
													}}
												/>
												{/*
												{!isFirstTimeSubmit &&
													!singleMapping.value &&
													singleMapping.isActive && (
														<p className="error-message">
															{singleMappingSection?.errorMessage}
														</p>
													)} */}
											</div>
										</div>

										{!isFirstTimeSubmit &&
											singleMapping.label.trim() === '' && (
												<p className="error-message">
													Please enter the field name
												</p>
											)}
									</div>
								);
							})}
					</div>
				</div>
			</div>
		);
	}

	// JSX
	return (
		<div
			className={`${styles['mapping-box']} ${
				!(
					isAddIntegrationPermission ||
					isEditIntegrationPermission ||
					isDeleteIntegrationPermission
				) && `${styles['remove-last']}`
			}`}
		>
			<div className={styles['mapping-box__wrapper']}>
				<div className={styles['mapping-box__top']}>
					<div className={styles['mapping-box__top--title-wrapper']}>
						<Tooltip title={singleMappingSection.toolTip}>
							<h5
								className={`${styles['mapping-box__top--title']} ${styles['mapping-box__top--title-cap']}`}
							>
								{singleMappingSection.capMappingTitle}
							</h5>
						</Tooltip>
					</div>

					<h5
						className={`${styles['mapping-box__top--title']} ${
							styles['mapping-box__top--title-qb']
						} ${
							singleMappingSection.id == 0 &&
							styles['mapping-box__top--title-qb-tooltip']
						}`}
					>
						{singleMappingSection.qbMappingValue}{' '}
						{singleMappingSection.id == 0 && (
							<Tooltip
								title={
									'Only Classes with subclasses will get synced for e.g. Parent Class: Sub Class'
								}
							>
								<div>
									<ToolTipInfo />
								</div>
							</Tooltip>
						)}
					</h5>
				</div>
				<div className={styles['mapping-box__center']}>
					{Object.values(singleMappingSection.fields)
						.sort((a: any, b: any) => a.priority - b.priority)
						.map((singleMapping: any, index: number) => {
							if (
								singleMappingSection.id === '0' &&
								singleMapping.id === 'f2'
							) {
								return null;
							}
							const selectBoxValue = findSelectBoxValueHandler(singleMapping);
							return (
								<div
									key={index}
									className={styles['mapping-box__center--wrapper']}
								>
									<div
										className={` ${styles['mapping-box__center--single-mapping']}`}
									>
										<div
											className={
												styles[
													'mapping-box__center--single-mapping--svg-wrapper'
												]
											}
										>
											<div className={styles['field-label']}></div>
											<div className={styles['edit-delete-wrapper']}></div>
										</div>
										<div
											className={
												styles[
													'mapping-box__center--single-mapping--select-wrapper'
												]
											}
										>
											{singleMappingSection.id === '1' && index === 0 ? (
												<div
													style={{ textAlign: 'center', marginBottom: '10px' }}
												>
													<h5
														className={`${styles['mapping-box__top--title']} ${styles['mapping-box__top--title-cap']}`}
													>
														GL Account - Debit
													</h5>
												</div>
											) : null}
										</div>
										{singleMappingSection.id == '1' ||
										singleMappingSection.id == '2' ||
										singleMappingSection.id == '3' ? (
											<div
												className={
													styles[
														'mapping-box__center--single-mapping--select-wrapper'
													]
												}
											>
												{singleMappingSection.id === '1' && index === 0 ? (
													<div
														style={{
															textAlign: 'center',
															marginBottom: '10px',
															fontSize: '12px',
														}}
													>
														<h5
															className={`${styles['mapping-box__top--title']} ${styles['mapping-box__top--title-cap']}`}
														>
															GL Account - Credit
														</h5>
													</div>
												) : null}
											</div>
										) : null}
										{singleMappingSection?.id == 2 &&
										Object.values(singleMappingSection.fields).length > 1 ? (
											<p style={{ width: '20px', fontSize: '12px' }}>
												{singleMapping.priority > 1 ? (
													// {/* // <button
													// // 	onClick={() => onChangeFieldPriority(
													// // 		singleMappingSection.id,
													// // 		singleMapping.id,
													// // 		singleMapping.priority - 1
													// // 	)}
													// // 	style={{ width: '30px', height: '30px', background: 'none', outline: 'none', border: 'none', cursor: 'pointer' }}
													// // >
													// // 	<UpArrowSvg/>
													// // </button> */}
													// <UpCircleOutlined
													// 	onClick={() =>
													// 		onChangeFieldPriority(
													// 			singleMappingSection.id,
													// 			singleMapping.id,
													// 			singleMapping.priority - 1
													// 		)
													// 	}
													// 	style={{
													// 		fontSize: '20px',
													// 	}}
													// />
													<></>
												) : null}
											</p>
										) : null}
									</div>
									<div
										className={` ${styles['mapping-box__center--single-mapping']}`}
									>
										<div
											className={
												styles[
													'mapping-box__center--single-mapping--svg-wrapper'
												]
											}
										>
											<div className={styles['field-label']}>
												{!singleMapping.isEditing ? (
													<div
														id={`${singleMappingSection.id}${singleMapping.id}`}
														style={{
															display: 'flex',
															alignItems: 'center',
															gap: '2px',
															flexWrap: 'nowrap',
														}}
													>
														<div style={{ flex: '1', minWidth: 0 }}>
															<WrappingEllipse
																message={singleMapping.label}
																maxLength={25} // Adjust based on your container width
																maxLines={2}
																isTooltip={true}
																tooltipMessage={singleMapping.label}
															/>
														</div>
														{singleMappingSection.id !== '5' &&
															!(
																singleMappingSection.id == '0' &&
																singleMapping.id === 'f1'
															) &&
															!(
																singleMappingSection.id == '4' &&
																!indirectExpenseRate
															) &&
															!(
																singleMappingSection.id == '0' &&
																singleMapping.id === 'f2' &&
																!indirectExpenseRate
															) &&
															singleMapping.isActive && (
																<span
																	className="required-field"
																	style={{ flexShrink: 0 }}
																>
																	*
																</span>
															)}
													</div>
												) : (
													<Input
														size="large"
														id={`${singleMappingSection.id}${singleMapping.id}`}
														defaultValue={singleMapping.label}
														style={{ width: '80%', fontSize: '12px' }}
														onChange={(event) => {
															settingsChangeHandler({
																sectionId: singleMappingSection.id,
																fieldId: singleMapping.id,
																fieldName: 'label',
																dataId: event.target.value,
															});
														}}
														onBlur={(event) => {
															const value = event.target.value.trim();
															if (value === '') {
																return;
															}
															settingsChangeHandler({
																sectionId: singleMappingSection.id,
																fieldId: singleMapping.id,
																fieldName: 'isEditing',
																dataId: !singleMapping.isEditing,
															});
														}}
													/>
												)}
											</div>
											<div className={styles['edit-delete-wrapper']}>
												{singleMapping.deletable &&
													isDeleteIntegrationPermission && (
														<>
															<Switch
																checked={singleMapping.isActive}
																onChange={(e) => {
																	onChangeFieldStatus &&
																		onChangeFieldStatus(
																			singleMappingSection.id,
																			singleMapping.id,
																			e
																		);
																}}
																style={{ marginRight: '10px' }} // Add margin to space out from the delete button
															/>
														</>
													)}

												{singleMapping.editable &&
													singleMapping.label.trim() !== '' &&
													isEditIntegrationPermission && (
														<>
															<label
																htmlFor={`${singleMappingSection.id}${singleMapping.id}`}
																className="cursor-pointer"
																onClick={() => {
																	settingsChangeHandler({
																		sectionId: singleMappingSection.id,
																		fieldId: singleMapping.id,
																		fieldName: 'isEditing',
																		dataId: !singleMapping.isEditing,
																	});
																}}
																style={{
																	marginRight: '10px',
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center',
																	padding: '8px',
																	borderRadius: '50%',
																	boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
																	transition: 'background-color 0.3s',
																	fontSize: '12px',
																}}
															>
																{singleMapping.isEditing ? (
																	// <p style={{ fontSize: '14px' }}>Save</p>
																	<></>
																) : (
																	<EditActionSvg />
																)}
															</label>
														</>
													)}

												{singleMappingSection?.type === 'qbCoa' &&
													(singleMappingSection.id === '1' ||
														singleMappingSection.id === '2' ||
														singleMappingSection.id === '3') && (
														<>
															{/* Tooltip for Delete Action */}

															<span
																// htmlFor={`delete-${singleMapping.id}`}
																className="cursor-pointer"
																onClick={() =>
																	showModal(singleMapping, singleMappingSection)
																} // Show the modal when clicked
																style={{
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center',
																	padding: '8px',
																	borderRadius: '50%',
																	boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
																	transition: 'background-color 0.3s',
																}}
															>
																<DeleteActionSvg />
															</span>

															{/* AntD Modal for delete confirmation */}
														</>
													)}
											</div>
										</div>
										<div
											className={
												styles[
													'mapping-box__center--single-mapping--select-wrapper'
												]
											}
										>
											{/* {singleMappingSection.id === '1' && index === 0 ? (
												<div
													style={{ textAlign: 'center', marginBottom: '10px' }}
												>
													<h5
														className={`${styles['mapping-box__top--title']} ${styles['mapping-box__top--title-cap']}`}
													>
														GL Account - Debit
													</h5>
												</div>
											) : null} */}
											{singleMappingSection?.type !== 'qbCustomer' &&
												singleMappingSection?.type !== 'qbClass' && (
													<Select
														placeholder={singleMappingSection?.placeHolder}
														size="large"
														getPopupContainer={(trigger) => trigger.parentNode}
														value={selectBoxValue}
														showSearch
														filterOption={(input, option: any) =>
															(option?.children as string)
																.toLowerCase()
																.indexOf(input.toLowerCase()) >= 0
														}
														onChange={(dataValue) => {
															settingsChangeHandler({
																sectionId: singleMappingSection.id,
																fieldId: singleMapping.id,
																fieldName: 'value',
																dataId: dataValue,
															});
														}}
														dropdownRender={(menu) => (
															<>
																{singleMappingSection.type === 'qbCoa' ? (
																	<>
																		{menu}
																		<Divider style={{ margin: '8px 0' }} />
																		<Space
																			style={{
																				padding: '0 8px 4px',
																				fontSize: '12px',
																			}}
																		>
																			<Button
																				type="text"
																				icon={<PlusOutlined />}
																				onClick={() => {
																					setIsNewAccountModalOpen(true);
																				}}
																				style={{
																					fontSize: '12px',
																				}}
																			>
																				Add new QuickBooks Account
																			</Button>
																		</Space>
																	</>
																) : (
																	<>{menu}</>
																)}
															</>
														)}
													>
														{singleMappingSection.id == '4' &&
														!indirectExpenseRate &&
														singleMappingSection.type === 'qbCoa' ? (
															<Select.Option value={''}>
																Select Account
															</Select.Option>
														) : !singleMapping.isActive ? (
															<Select.Option value={''}>
																Select Account
															</Select.Option>
														) : null}
														{filteredItems.map((qbData: any, key: number) => {
															if (singleMappingSection.type === 'qbCoa') {
																return (
																	<Select.Option
																		value={qbData?.Id}
																		key={key}
																		// disabled={
																		// 	singleMappingSection.id == '1' ||
																		// 	singleMappingSection.id == '2' ||
																		// 	singleMappingSection.id == '3'
																		// 		? qbData.isDisable &&
																		// 		  qbData?.Id !==
																		// 				singleMapping.creditValue
																		// 		: qbData.isDisable
																		// }
																	>
																		{qbData?.Name}
																	</Select.Option>
																);
															} else if (
																singleMappingSection.type === 'qbCustomer'
															) {
																return (
																	<Select.Option
																		value={qbData?.Id}
																		key={key}
																		disabled={qbData.isDisable}
																	>
																		{qbData?.title}
																		{/* {qbData?.DisplayName} */}
																	</Select.Option>
																);
															} else if (
																singleMappingSection.type === 'qbClass'
															) {
																return (
																	<Select.Option
																		value={qbData?.Id}
																		key={key}
																		disabled={qbData.isDisable}
																	>
																		{qbData?.FullyQualifiedName}
																	</Select.Option>
																);
															}
														})}
													</Select>
												)}

											{(singleMappingSection?.type === 'qbCustomer' ||
												singleMappingSection?.type === 'qbClass') && (
												<TreeSelect
													showSearch
													placeholder={singleMappingSection?.placeHolder}
													size="large"
													getPopupContainer={(trigger) => trigger.parentNode}
													value={selectBoxValue}
													onChange={(dataValue) => {
														settingsChangeHandler({
															sectionId: singleMappingSection.id,
															fieldId: singleMapping.id,
															fieldName: 'value',
															dataId: dataValue,
														});
													}}
													dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
													allowClear={false}
													treeDefaultExpandAll
													treeData={filteredItems}
													filterTreeNode={(inputValue, treeNode) => {
														// Customize the filtering logic here
														return treeNode.props.title
															.toLowerCase()
															.includes(inputValue.toLowerCase());
													}}
												/>
											)}

											{!isFirstTimeSubmit &&
												!singleMapping.value &&
												singleMappingSection.id !== '5' &&
												!(
													singleMappingSection.id == '0' &&
													singleMapping.id === 'f1'
												) &&
												!(
													singleMappingSection.id == '4' && !indirectExpenseRate
												) &&
												!(
													singleMappingSection.id == '0' &&
													singleMapping.id === 'f2' &&
													!indirectExpenseRate
												) &&
												singleMapping.isActive && (
													<p className="error-message">
														{singleMappingSection?.errorMessage}
													</p>
												)}
										</div>
										{singleMappingSection.id == '1' ||
										singleMappingSection.id == '2' ||
										singleMappingSection.id == '3' ? (
											<div
												className={
													styles[
														'mapping-box__center--single-mapping--select-wrapper'
													]
												}
											>
												{/* {singleMappingSection.id === '1' && index === 0 ? (
													<div
														style={{
															textAlign: 'center',
															marginBottom: '10px',
														}}
													>
														<h5
															className={`${styles['mapping-box__top--title']} ${styles['mapping-box__top--title-cap']}`}
														>
															GL Account - Credit
														</h5>
													</div>
												) : null} */}
												<Select
													placeholder={singleMappingSection?.placeHolder}
													size="large"
													getPopupContainer={(trigger) => trigger.parentNode}
													value={singleMapping?.creditValue}
													showSearch
													filterOption={(input, option: any) =>
														(option?.children as string)
															.toLowerCase()
															.indexOf(input.toLowerCase()) >= 0
													}
													onChange={(dataValue) => {
														settingsChangeHandler({
															sectionId: singleMappingSection.id,
															fieldId: singleMapping.id,
															fieldName: 'creditValue',
															dataId: dataValue,
														});
													}}
													dropdownRender={(menu) => (
														<>
															{singleMappingSection.type === 'qbCoa' ? (
																<>
																	{menu}
																	<Divider style={{ margin: '8px 0' }} />
																	<Space
																		style={{
																			padding: '0 8px 4px',
																			fontSize: '12px',
																		}}
																	>
																		<Button
																			type="text"
																			icon={<PlusOutlined />}
																			onClick={() => {
																				setIsNewAccountModalOpen(true);
																			}}
																			style={{
																				fontSize: '12px',
																			}}
																		>
																			Add new QuickBooks Account
																		</Button>
																	</Space>
																</>
															) : (
																<>{menu}</>
															)}
														</>
													)}
												>
													{singleMappingSection.id == '4' &&
													!indirectExpenseRate &&
													singleMappingSection.type === 'qbCoa' ? (
														<Select.Option value={''}>
															Select Account
														</Select.Option>
													) : !singleMapping.isActive ? (
														<Select.Option value={''}>
															Select Account
														</Select.Option>
													) : null}
													{filteredItems.map((qbData: any, key: number) => {
														return (
															<Select.Option
																value={qbData?.Id}
																key={key}
																// disabled={
																// 	qbData.isDisable
																// 	//  && qbData?.Id !== singleMapping.value
																// }
															>
																{qbData?.Name}
															</Select.Option>
														);
													})}
												</Select>

												{!isFirstTimeSubmit &&
													!singleMapping.creditValue &&
													singleMappingSection.id !== '5' &&
													!(
														singleMappingSection.id == '0' &&
														singleMapping.id === 'f1'
													) &&
													!(
														singleMappingSection.id == '4' &&
														!indirectExpenseRate
													) &&
													!(
														singleMappingSection.id == '0' &&
														singleMapping.id === 'f2' &&
														!indirectExpenseRate
													) &&
													singleMapping.isActive && (
														<p className="error-message">
															{singleMappingSection?.errorMessage}
														</p>
													)}
											</div>
										) : null}
										{(singleMappingSection?.id == 2 ||
											singleMappingSection?.id == 1 ||
											singleMappingSection?.id == 3) &&
										Object.values(singleMappingSection.fields).length > 1 ? (
											<p style={{ width: '20px' }}>
												{/* {JSON.stringify(singleMapping.priority)} */}
												{(
													singleMappingSection?.id == 1
														? singleMapping.priority >= 2
														: singleMapping.priority > 1
												) ? (
													// <button
													// 	onClick={() => onChangeFieldPriority(
													// 		singleMappingSection.id,
													// 		singleMapping.id,
													// 		singleMapping.priority - 1
													// 	)}
													// 	style={{ width: '30px', height: '30px', background: 'none', outline: 'none', border: 'none', cursor: 'pointer' }}
													// >
													// 	{/* <UpArrowSvg/> */}
													// 	UP
													// </button>
													<UpCircleOutlined
														onClick={() =>
															onChangeFieldPriority(
																singleMappingSection.id,
																singleMapping.id,
																singleMapping.priority > 1 &&
																	singleMapping.priority - 1
															)
														}
														style={{
															fontSize: '20px',
														}}
													/>
												) : null}
											</p>
										) : null}
									</div>
									<div>
										{!isFirstTimeSubmit &&
											singleMapping.label.trim() === '' && (
												<p className="error-message">
													Please enter the field name
												</p>
											)}
									</div>
								</div>
							);
						})}

					{/* Add customer dropdown inline with section 0
					{singleMappingSection.id === '0' && customerSection && (
						<div className={styles['mapping-box__center--wrapper']}>
							<div className={` ${styles['mapping-box__center--single-mapping']}`}>
								<div className={styles['mapping-box__center--single-mapping--svg-wrapper']}>
									<div className={styles['field-label']}></div>
									<div className={styles['edit-delete-wrapper']}></div>
								</div>
								<div className={styles['mapping-box__center--single-mapping--select-wrapper']}>
									<h5 className={`${styles['mapping-box__top--title']} ${styles['mapping-box__top--title-qb']}`}>
										{customerSection.qbMappingValue}
									</h5>
								</div>
							</div>
							<div className={` ${styles['mapping-box__center--single-mapping']}`}>
								<div className={styles['mapping-box__center--single-mapping--svg-wrapper']}>
									<div className={styles['field-label']}></div>
									<div className={styles['edit-delete-wrapper']}></div>
								</div>
								<div className={styles['mapping-box__center--single-mapping--select-wrapper']}>
									<TreeSelect
										showSearch
										placeholder={customerSection.placeHolder}
										size="large"
										getPopupContainer={(trigger) => trigger.parentNode}
										value={customerSection.fields.f1.value}
										onChange={(dataValue) => {
											settingsChangeHandler({
												sectionId: customerSection.id,
												fieldId: 'f1',
												fieldName: 'value',
												dataId: dataValue,
											});
										}}
										dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
										allowClear={false}
										treeDefaultExpandAll
										treeData={customerFilteredItems}
										filterTreeNode={(inputValue, treeNode) => {
											return treeNode.props.title
												.toLowerCase()
												.includes(inputValue.toLowerCase());
										}}
									/>
									{!isFirstTimeSubmit && !customerSection.fields.f1.value && customerSection.fields.f1.isActive && (
										<p className="error-message">
											{customerSection.errorMessage}
										</p>
									)}
								</div>
							</div>
						</div>
					)} */}
				</div>

				{singleMappingSection.addMore &&
					isAddIntegrationPermission &&
					Object.values(singleMappingSection.fields).length < 20 && (
						<div className={styles['mapping-box__bottom']}>
							<div onClick={() => addFieldHandler(singleMappingSection.id)}>
								<BlueAddSvg />
								<p className={styles['mapping-box__bottom--add-more']}>
									Add Another Item
								</p>
							</div>
						</div>
					)}
			</div>
			{isNewAccountModalOpen && (
				<div className="qbo-account">
					<Modal
						open={isNewAccountModalOpen}
						footer={false}
						onCancel={handleModalClose}
						className="qbo-account-modal"
						closable={false}
					>
						<Row className={styles['qbo-modal__header']}>
							<div className="userDetailsTitle">
								<p style={{ fontSize: '16px' }}>Add new QuickBooks account</p>
							</div>
							<div
								className={styles['qbo-modal__header-close']}
								onClick={handleModalClose}
							>
								<CloseSvg />
							</div>
						</Row>
						<hr />
						<Form
							name="basic"
							wrapperCol={{ span: 16 }}
							style={{ maxWidth: 600 }}
							autoComplete="off"
							form={form}
							labelCol={{ span: 8 }}
							onFinish={handleSubmit}
						>
							<div className="qbo-account-form">
								<Form.Item
									label="Account Type"
									name="accountType"
									className="qbo-account-form__field"
									// initialValue={'Expense'}
								>
									{/* <Input
										disabled
										size="large"
										className="qbo-account-form__field-input"
									/> */}
									<Select
										size="large"
										className="qbo-account-form__field-input"
										defaultValue={'Expense'}
										onChange={handleAccountTypeChange}
									>
										<Select.Option value="Expense"> Expense </Select.Option>
										<Select.Option value="Other Expense">
											{' '}
											Other Expense{' '}
										</Select.Option>
										<Select.Option value="Cost of Goods Sold">
											{' '}
											Cost of Goods Sold{' '}
										</Select.Option>
										<Select.Option value="Other Current Liability">
											{' '}
											Other Current Liability{' '}
										</Select.Option>
										<Select.Option value="Long Term Liability">
											{' '}
											Long Term Liability{' '}
										</Select.Option>
									</Select>
								</Form.Item>

								<Form.Item
									label="Account Name"
									name="accountName"
									rules={[
										{ required: true, message: 'Please enter account name!' },
									]}
								>
									<Input
										size="large"
										className="qbo-account-form__field-input"
									/>
								</Form.Item>

								<Form.Item
									label="Detail Type"
									name="detailType"
									rules={[
										{
											required: true,
											message: 'Account detail type is required!',
										},
									]}
								>
									<Select
										style={{ width: 200 }}
										size="large"
										placeholder="Account"
										showSearch
										// value={
										// 	DetailType[accountType as keyof typeof DetailType][0]
										// 		.value
										// // }
										// value={detailTypeValue}
										// onChange={setDetailTypeValue}
										filterOption={(input, option: any) =>
											(option?.children as string)
												.toLowerCase()
												.indexOf(input.toLowerCase()) >= 0
										}
									>
										{detailTypeOptions.map((account: any) => (
											<Select.Option
												key={account.value}
												value={account.value}
											>
												{account.label}
											</Select.Option>
										))}
									</Select>
								</Form.Item>
								<Form.Item
									label="Account Number"
									name="accountNumber"
								>
									<InputNumber
										size="large"
										type="number"
										style={{ fontSize: '12px' }}
									/>
								</Form.Item>
							</div>

							<hr />

							<Row
								justify="start"
								className={`${styles['buttons']}`}
								gutter={16}
							>
								<Col
									xs={12}
									md={7}
									lg={7}
									sm={8}
								>
									<button
										className={`${styles['save']}`}
										type="submit"
										// onClick={handleSubmit}
									>
										{isAccountLoading ? (
											<img
												src="/assets/gifs/loading-black.gif"
												height={40}
											/>
										) : (
											'Save'
										)}
									</button>
								</Col>
								<Col
									xs={12}
									md={7}
									lg={7}
									sm={8}
								>
									<button
										className={styles['cancel']}
										onClick={handleModalClose}
									>
										Cancel
									</button>
								</Col>
							</Row>
						</Form>
					</Modal>
				</div>
			)}

			<Modal
				title={
					<div style={{ padding: '5px 0', margin: 0, fontSize: '16px' }}>
						Confirm Deletion
					</div>
				} // Adjusting padding and margin of title
				open={isModalVisible}
				// onOk={handleDelete} // On confirm, handle the delete
				onCancel={handleCancel} // On cancel, close the modal
				// okText="Delete"
				// cancelText="Cancel"
				style={{ opacity: 1 }}
				centered
				footer={[
					// Custom footer to align buttons to the left
					<div
						style={{
							paddingTop: '10px',
						}}
						key="footer"
					>
						<Button
							key="cancel"
							type="primary"
							onClick={handleCancel}
							style={{
								marginRight: '8px',
								backgroundColor: 'white',
								color: '#172014',
								borderColor: '#344735',
								fontSize: '12px',
								borderRadius: '12px',
							}}
						>
							Cancel
						</Button>
						<Button
							key="delete"
							type="primary"
							onClick={handleDelete}
							style={{
								backgroundColor: '#344735',
								borderColor: '#344735',
								fontSize: '12px',
								borderRadius: '12px',
							}}
						>
							Delete
						</Button>
					</div>,
				]}
			>
				<p
					style={{
						fontSize: '12px',
					}}
				>
					Are you sure you want to delete the account{' '}
					<strong>{singleMappingToDelete?.label}</strong>?
				</p>
				<Card style={{ padding: '10px', marginTop: '10px' }}>
					<p style={{ color: 'red', fontWeight: 600, fontSize: '12px' }}>
						Warning: Deleting this account will permanently remove all
						associated data from selected pay period, including employee cost
						information.
					</p>
				</Card>
			</Modal>
		</div>
	);
};

export default MappingBox;
